import { AppSettings } from "@/repository/models/app";

export interface AppCacheState {
	cache: Record<string, any>;
}

export interface AppCacheActions {
	setCache: (key: CacheKey, value: any) => void;
	removeCaches: (keys: CacheKey[]) => void;
}

export enum CacheKey {
	ContactsSearch = "contactsSearch",
	ContactsQueueIds = "ContactsQueueIds",
	ContactsTypeFilter = "contactsTypeFilter",
	ContactsAdvancedFilter = "contactsAdvancedFilter",
	ResourcesSearch = "resourcesSearch",
	CurrentInteractionId = "currentInteractionId",
	PreviewInteractionId = "previewInteractionId",
	OfferingCallId = "offeringCallId",
	WrapUpInteractionInfo = "WrapUpInteractionInfo",
	CurrentWrapUpCodeId = "CurrentWrapUpCodeId",
	CurrentWrapUpCodeName = "CurrentWrapUpCodeName",
	OnHoldStatus = "onHoldStatus",
	OutboundEndpoint = "outboundEndpoint",
	OutboundEmailEndpoint = "outboundEmailEndpoint",
	HistorySearch = "historySearch",
	HistorySort = "historySort",
	HistoryFilter = "historyFilter",
	HistoryQueueIds = "historyQueueIds",
	HistoryTableSettings = "HistoryTableSettings",
	AcceptedInteractionId = "acceptedInteractionId",
	CallInProgress = "callInProgress",
	ActiveListFilterData = "activeListFilterData",
	WaitingListFilterData = "waitingListFilterData",
	SupervisorAgentsFilterData = "supervisorAgentsFilterData",
	OfferingDynamicUrlCallId = "offeringDynamicUrlCallId",
	AcceptedDynamicUrlCallId = "acceptedDynamicUrlCallId",
	RemoveDynamicUrlCallId = "removeDynamicUrlCallId",
	TemplatesSearch = "templatesSearch",
	InteractionTypeFilterValues = "interactionTypeFilterValues",
	ContactsTransferSearch = "contactsTransferSearch",
	ContactsTransferSearchText = "contactsTransferSearchText",
	SessionVariableText = "sessionVariabletext",
	InteractionPanelWidth = "interactionPanelWidth",
	ToggledViewPanelWidth = "toggledViewPanelWidth",
	WhatsApp = "WhatsApp",
	Webchat = "Webchat",
	Transcription = "Transcription",
	MessagingVariableText = "MessagingVariableText",
	InteractionSearchValue = "InteractionSearchValue",
	InteractionQueueIds = "InteractionQueueIds",
	ContactsSelectedTab = "ContactsSelectedTab",
	AllWaitingInteractionsPanelWidth = "allWaitingInteractionsPanelWidth",
	OpenedInteractionSections = "OpenedInteractionSections",

	ActiveInteractionsTableSettings = "ActiveInteractionsTableSettings",
	SupervisedAgentsTableSettings = "SupervisedAgentsTableSettings",
	OutboundType = "OutboundType",
	PreviousTab = "PreviousTab",
	EmailThreadSortOrder = "emailThreadSortOrder",
}

export interface AppSettingsState {
	settings: AppSettings;
	timeDiference: number;
}

export interface AppSettingsActions {
	setSettings: (settings: AppSettings) => void;
}
